var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167461",
    "data-name": "Group 167461",
    transform: "translate(-5650 -4840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(5650 4840)",
    fill: "#ffefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167018",
    "data-name": "Group 167018",
    transform: "translate(5672 4880.385) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x2: 26,
    transform: "translate(0 12.381)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 26,
    transform: "translate(13 0) rotate(90)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendErrorIcon);
export default __webpack_public_path__ + "static/media/send_error_icon.f12e261065050c871e3eceda4ec7521f.svg";
export { ForwardRef as ReactComponent };